export default __webpack_public_path__ + "static/media/bbot-logo-black.1fb64d50.svg";